<template>
  <header>
    <div class="container-fluid">
      <div class="row">
        <div class="header-filtering">
          <button id="show-filter">
            <img src="../../asset2/img/filter.svg">
          </button>
          <form method="post" style="padding-top: 4px;">
            <div class="filtering-form">
              <span class="close">&times;</span>
              <div class="styled-select">
                <SelectBox :items="farms" v-model="farm"
                           @input="onFilterChange('farm')">Farms
                </SelectBox>
              </div>
              <div class="styled-select">
                <SelectBox :items="fields" v-model="field"
                           @input="onFilterChange('field')">Fields
                </SelectBox>
              </div>
              <label>Compare</label>
              <div class="styled-select">
                <SelectBox :items="farmsTwo" v-model="farmTwo"
                           @input="onFilterChange('farmTwo')">Farms
                </SelectBox>
              </div>
              <div class="styled-select">
                <SelectBox :items="fieldsTwo" v-model="fieldTwo"
                           @input="onFilterChange('fieldTwo')">Fields
                </SelectBox>
              </div>
              <DatePicker v-model="startDate" @input="onFilterChange('fromDate')">From</DatePicker>
              <DatePicker v-model="endDate" @input="onFilterChange('toDate')">To</DatePicker>
            </div>
          </form>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

  require('../../asset2/css/main.min.css');

  export default {
    name: 'HeaderBar',

    data() {
      return {
        items: [],
        farm: null,
        field: null,
        farms: [],
        fields: [],
        farmTwo: null,
        fieldTwo: null,
        farmsTwo: [],
        fieldsTwo: [],
        startDate : null,
        endDate: null
      };
    },

    created() {
      this.loadRelatedData();
    },

    methods: {
      onFilterChange (changeField) {
        if (changeField === 'farm' || changeField === 'farmTwo') {
          this.getFieldValues(changeField);
        }
        this.$emit('onFilterChange', this.getParams())
      },

      getParams () {
        const params = {}
        if (this.farm) {
          params.farmUid = this.farm
        }
        if (this.farmTwo) {
          params.farmUidTwo = this.farmTwo
        }
        if (this.field) {
          params.fieldUid = this.field
        }
        if (this.fieldTwo) {
          params.fieldUidTwo = this.fieldTwo
        }
        if (this.startDate) {
          params.startDate = this.startDate
        }
        if (this.endDate) {
          params.endDate = this.endDate
        }
        return params
      },

      async loadRelatedData() {
        let [getFarmsReq] = await Promise.all([
          this.axios.get('monterre/getFarms')
        ]);
        if (getFarmsReq.data && getFarmsReq.data.data) {
          this.setSelectedItems(getFarmsReq.data.data, 'farms');
          this.setSelectedItems(getFarmsReq.data.data, 'farmsTwo');
        }
    },

      setSelectedItems(items, code) {
        const mType = items.map(item => {
          return {text: item.name, value: item.uuid + ''};
        });
        mType.unshift({value: null, text: 'Select'});
        this[code] = mType;
      },

      getFieldValues(fieldType) {
        if (fieldType === 'farm') {
          this.fields = [];
        } else if (fieldType === 'farmTwo') {
          this.fieldsTwo = [];
        }
        var farmuuid = fieldType === 'farm' ? this.farm : this.farmTwo;
        this.axios.get('monterre/getFields', {params: {farmuuid: farmuuid}})
            .then(response => {
              if (response.data.data && response.data.data) {
                if (fieldType === 'farm') {
                  this.setSelectedItems(response.data.data, 'fields');
                } else {
                  this.setSelectedItems(response.data.data, 'fieldsTwo');
                }
              }
            })
            .catch(error => {
              if (error.response && error.response.data.status === 400) {
                this.$toastr.error(error.response.data.message);
              }
            });
      },

    async mounted() {
    }
  }

  };
</script>

<style scoped>

</style>
